import { registration_path } from "@/routes";
import { router } from "@inertiajs/react";
import { useEffect } from "react";

export default function RegistrationNewPage() {
  useEffect(() => {
    router.post(registration_path());
  }, []);

  return null;
}
